import Style from './container.module.scss';
import { useNode, NodeHelpersType, Node, Element } from '@craftjs/core';
import {
  FormRepeatableContainerComponent,
  FormRepeatableSection,
  formRepeatableSectionDefaultProps,
} from 'src/features/generalForms/builder/types/RepeatableContainer';
import { LayoutPanel, LogicPanel, TitlePanel } from 'src/features/generalForms/builder/layout/panels';
import { RepeatableContainerPanel } from 'src/features/generalForms/builder/layout/panels/repeatableContainerPanel';

export const RepeatableContainer: FormRepeatableContainerComponent = ({ title }) => {
  const { connectors } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;

  return (
    <div className={Style.repeatableContainerWithTitle} ref={(ref) => connect(drag(ref!))}>
      {title && <div className={Style.title}>{title}</div>}
      <div className={Style.repeatableContainer}>
        <Element canvas={true} id={'id'} is={RepeatableSection} {...formRepeatableSectionDefaultProps} />
      </div>
    </div>
  );
};

const RepeatableContainerSettings = () => (
  <>
    <TitlePanel sections={['DataKey', 'Title']} />
    <RepeatableContainerPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

RepeatableContainer.craft = {
  displayName: 'RepeatableContainer',
  rules: {
    canDrag: () => true,
    canMoveIn: () => false,
    // Prevent nested RepeatableContainers
    canDrop: (dropTarget: Node, self: Node, helpers: NodeHelpersType) =>
      !helpers(dropTarget.id)
        .ancestors(true)
        .map((nodeId) => helpers(nodeId).toSerializedNode().displayName)
        .some((displayName) => displayName === 'RepeatableContainer'),
  },
  related: { settings: RepeatableContainerSettings },
};

export const RepeatableSection: FormRepeatableSection = ({ children, sectionTitle }) => {
  const { connectors, styles } = useNode((node) => ({
    styles: node.data.custom,
  }));

  const { connect, drag } = connectors;
  return (
    <div ref={(ref) => connect(drag(ref!))}>
      {!!sectionTitle && <div className={Style.sectionTitle}>{sectionTitle}</div>}
      <div className={Style.repeatableSection} style={styles}>
        {children}
      </div>
    </div>
  );
};

const RepeatableSectionSettings = () => (
  <>
    <TitlePanel sections={['SectionTitle']} />
    <LayoutPanel sections={['ContentLayout', 'Paddings', 'HorizontalAlignment', 'VerticalAlignment']} />
  </>
);

RepeatableSection.craft = {
  displayName: 'RepeatableSection',
  rules: {
    canDrag: () => false,
    canMoveIn: () => true,
  },
  related: { settings: RepeatableSectionSettings },
};
